import { useUtmRedirect } from '@/hooks/useUtmRedirect';

/**
 * Component wrapper for UTM redirect logic
 * Place inside BrowserRouter to enable auto-redirects
 */
const UtmRedirectHandler = () => {
  useUtmRedirect();
  return null;
};

export default UtmRedirectHandler;
